import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';
import { TypeUtils } from '@vectord/utils';
import cogoToast from 'cogo-toast';

import {
  newDateOfTopicSelector,
  RESCHEDULE_REASON_MODAL_STAGES,
  rescheduleReasonSelector,
  rescheduleSbatGroupCommunicationsSelector,
  rescheduleSbatGroupValidateErrorMessageSelector,
  resetRescheduleModal,
  selectedSbatGroupSelector,
  setRescheduleModalStage,
  setRescheduleSbatGroupErrors,
  useSbatGroupConfirmation,
  useUpdateSbatGroupMutation,
} from 'features/classCreation';

export default function RescheduleModalValidationStage() {
  const dispatch = useDispatch();
  const communications = useSelector(rescheduleSbatGroupCommunicationsSelector);
  const rescheduleReason = useSelector(rescheduleReasonSelector);
  const newDateOfTopic = useSelector(newDateOfTopicSelector);
  const sbatGroup = useSelector(selectedSbatGroupSelector);
  const [updateAcademyTopic, { isSuccess, error, isLoading: isUpdating }] =
    useUpdateSbatGroupMutation();
  const errorMessage = useSelector(
    rescheduleSbatGroupValidateErrorMessageSelector
  );

  const handleCancel = useCallback(() => {
    dispatch(setRescheduleModalStage(RESCHEDULE_REASON_MODAL_STAGES.reason));
  }, [dispatch]);

  const handleSbatGroupUpdate = useCallback(() => {
    const comms = Object.keys(communications).filter(
      (key) => communications[key]
    );

    updateAcademyTopic({
      sbatGroup: sbatGroup,
      newDateOfTopic,
      reason: rescheduleReason?.customReason || rescheduleReason?.label,
      notificationChannels: comms,
    });
  }, [
    communications,
    newDateOfTopic,
    rescheduleReason,
    sbatGroup,
    updateAcademyTopic,
  ]);

  const handleProceed = useSbatGroupConfirmation(
    handleSbatGroupUpdate,
    sbatGroup
  );

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Class date and time is updated successfully!');
      batch(() => {
        dispatch(resetRescheduleModal());
        dispatch(setRescheduleSbatGroupErrors(null));
      });
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      const errors = error.data?.message;
      if (TypeUtils.isString(errors)) {
        cogoToast.error(error?.data?.message);
      } else {
        dispatch(setRescheduleSbatGroupErrors({ base: errors.base }));
        cogoToast.error(
          'There was some problem in updating the class date and time. Please try again later!'
        );
      }
    }
  }, [dispatch, error]);

  return (
    <div className="column justify-c align-c">
      <div className="row">
        <Icon
          name="warning"
          className="h2 m-r-xxs danger"
        />
        <div className="dark h4 text-c m-b-m m-r-m">{errorMessage}</div>
      </div>
      <div>
        <Tappable
          className="btn btn-danger btn-long"
          onClick={handleProceed}
          disabled={isUpdating}
        >
          Yes
        </Tappable>
        <Tappable
          className="btn btn-long m-l-xxs"
          onClick={handleCancel}
          disabled={isUpdating}
        >
          No
        </Tappable>
      </div>
    </div>
  );
}
